<app-foldseek-table
  [afdb_accession]="afdb_accession"
  [accession]="accession"
></app-foldseek-table>

<!-- @if(providerData().providerName === 'Google DeepMind'){ -->

<div class="sectionContent"></div>
  <app-cluster-table
    [accession]="accession" [uniprotAccession]="uniprotAccession">
  </app-cluster-table>
<!-- } -->




